<app-common-header></app-common-header>
<main role="main" class="maincnt quest">
  <div class="getbannersect pb-2">
    <div class="col-sm-12 p-0">
      <a
        href="javascript:void(0)"
        class="backbtn webview arrowlft"
        (click)="back()"
      ></a>
    </div>
    <div class="sectpad container">
      <div class="col-12 text-center webview">
        <!-- <img src="assets/images/eva-icons.svg" class="signimg" width="100" /> -->
      </div>
      <div class="col-sm-12 pt-4 pl-0 pr-0 mt-5">
        <h1 class="text-center fwgtsix font40 webview">
          Signing up for {{ selectedProduct.energy_provider }} <br />
          is just one phone call away
        </h1>
        <div class="container mobileview mt-0 pr-0 pt-4">
          <div class="d-flex h-100 row col-sm-12 pr-3 mt-0">
            <div
              class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
            >
              <img
                style="width: 100% !important"
                src="assets/images/signimg.jpg"
              />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div class="arrow_box">
                <h1 class="questionMob text-left">
                  Signing up for {{ selectedProduct.energy_provider }} is just
                  one phone call away.
                </h1>
              </div>
            </div>
            <span
              class="ssnTxt d-inline-block mt-3"
              style="
                font-family: Calibre;
                font-size: 19px;
                line-height: 19px;
                font-weight: 400;
              "
              >{{ selectedProduct.energy_provider }} gives you the freedom and
              flexibility to be in control of your electricity costs. You decide
              how much electricity you want to use and how much you want to
              spend.
              <br />
              <dl>
                <dt style="font-weight: 0 !important">
                  <img
                    src="assets/images/prepaid-checkBox.svg"
                    style="margin-right: 5px; margin-top: -3px"
                    width="15"
                  />No credit check
                </dt>
                <dt style="font-weight: 0 !important">
                  <img
                    src="assets/images/prepaid-checkBox.svg"
                    style="margin-right: 5px; margin-top: -3px"
                    width="15"
                  />No deposit
                </dt>
                <dt style="font-weight: 0 !important">
                  <img
                    src="assets/images/prepaid-checkBox.svg"
                    style="margin-right: 5px; margin-top: -3px"
                    width="15"
                  />No cancellation fee
                </dt>
                <dt style="font-weight: 0 !important">
                  <img
                    src="assets/images/prepaid-checkBox.svg"
                    style="margin-right: 5px; margin-top: -3px"
                    width="15"
                  />Everyone is approved
                </dt>
                <dt style="font-weight: 0 !important">
                  <img
                    src="assets/images/prepaid-checkBox.svg"
                    style="margin-right: 5px; margin-top: -3px"
                    width="15"
                  />Same day activation
                </dt>
              </dl>
              <span
                class="ssnTxt d-inline-block mt-3"
                style="
                  font-family: Calibre;
                  font-size: 19px;
                  line-height: 19px;
                  font-weight: 400;
                "
              >
                All that is required is a valid email and cell phone number with
                SMS text capability. You must be able to receive texts or emails
                as this is how {{ selectedProduct.energy_provider }} will alert
                you when it is time to reload your account.</span
              >
            </span>
          </div>
        </div>
        <div class="col-sm-10 m-auto p-0 mbwidth">
          <div class="card-wrapper m-auto webview">
            <div class="col-md-11 m-auto">
              <span
                class="ssnTxt d-inline-block mt-3"
                style="
                  font-family: Calibre;
                  font-size: 19px;
                  line-height: 19px;
                  font-weight: 400;
                "
                >{{ selectedProduct.energy_provider }} gives you the freedom and
                flexibility to be in control of your electricity costs. You
                decide how much electricity you want to use and how much you
                want to spend.
              </span>
              <span class="ssnTxt d-inline-block mt-3">
                <dl>
                  <dt style="font-weight: 0 !important">
                    <img
                      src="assets/images/prepaid-checkBox.svg"
                      style="margin-right: 5px; margin-top: -3px"
                      width="15"
                    />No credit check
                  </dt>
                  <dt style="font-weight: 0 !important">
                    <img
                      src="assets/images/prepaid-checkBox.svg"
                      style="margin-right: 5px; margin-top: -3px"
                      width="15"
                    />No deposit
                  </dt>
                  <dt style="font-weight: 0 !important">
                    <img
                      src="assets/images/prepaid-checkBox.svg"
                      style="margin-right: 5px; margin-top: -3px"
                      width="15"
                    />No cancellation fee
                  </dt>
                  <dt style="font-weight: 0 !important">
                    <img
                      src="assets/images/prepaid-checkBox.svg"
                      style="margin-right: 5px; margin-top: -3px"
                      width="15"
                    />Everyone is approved
                  </dt>
                  <dt style="font-weight: 0 !important">
                    <img
                      src="assets/images/prepaid-checkBox.svg"
                      style="margin-right: 5px; margin-top: -3px"
                      width="15"
                    />Same day activation
                  </dt>
                </dl>
              </span>
              <span
                class="ssnTxt d-inline-block mt-3 mb-3"
                style="
                  font-family: Calibre;
                  font-size: 19px;
                  line-height: 19px;
                  font-weight: 400;
                "
              >
                All that is required is a valid email and cell phone number with
                SMS text capability. You must be able to receive texts or emails
                as this is how
                {{ selectedProduct.energy_provider }} will alert you when it is
                time to reload your account.</span
              >
            </div>
          </div>
          <div class="font18 text-center mt-4 mb-4 fwgtfive">
            <p style="font-size: 30px; font-weight: 500">
              To complete the signup, click or dial
            </p>
            <p
              style="
                color: #0055ff !important;
                font-size: 30px;
                font-weight: 500;
              "
            >
              <a [href]="selectedContactNumber">
                {{ selectedProduct.providerContact }}
              </a>
            </p>
            <p style="font-family: Calibre; font-size: 15px; font-weight: bold">
              Mention promo code: “{{ selectedProduct.promoCode }}”
            </p>
            <p style="font-family: Calibre; font-size: 15px; line-height: 15px">
              {{ selectedProduct.providerOperationHours }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
